import React from 'react';
import JournalSection from '../../JournalSection/JournalSection';
import SessionNameField from '../../SessionNameField/SessionNameField';

const JournalTab = ({
  sections,
  selectedTemplate,
  displayDate,
  hasPartial,
  hasFinal,
  isTranscribing,
  onSectionChange,
  onDeleteSection,
  onCopyContent,
  readOnly = false,
  sessionId = null,  // Pass session ID for prioritization
  sessionName = '',
  onSessionNameChange
}) => {
  return (
    <>
      {/* Session Name Field - editable session name */}
      {sessionId && (
        <SessionNameField
          sessionId={sessionId}
          initialName={sessionName}
          onNameChange={onSessionNameChange}
          placeholder="Namnge journalen..."
        />
      )}

      <h3>
        Journal
        {selectedTemplate?.template_name
          ? `: ${selectedTemplate.template_name}`
          : ":"}
      </h3>
      {displayDate && (
        <div className="journal-date">Genererad: {displayDate}</div>
      )}

      {sections.map((sec, idx) => (
        <JournalSection
          key={idx}
          index={idx}
          section={sec}
          handleSectionChange={onSectionChange}
          handleDeleteSection={onDeleteSection}
          handleCopyContent={() => onCopyContent((sec.content || '').trim())}
          showDeleteButton={!readOnly}
          showCopyButton={!readOnly}
          isStreaming={hasPartial}
          readOnly={readOnly}
          sessionId={sessionId}
        />
      ))}

      {isTranscribing && (
        <div className="journal-generation-overlay">
          <div className="journal-generation-content">
            <div className="spinner"></div>
            <h3>Aion genererar din journal</h3>
            <p>Vänta medan vi skapar din journalanteckning...</p>
          </div>
        </div>
      )}

      {!isTranscribing && sections.length === 0 && <p>Ingen journal genererad.</p>}
    </>
  );
};

export default JournalTab;